import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { ReplaceTextPipe, TitleTextPipe } from './custom.pipe';
import { Location } from '@angular/common';

// MSAL Imports
import { MsalModule, MsalService, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

// 🔐 MSAL Configuration
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: 'e3930981-5471-43b5-a4ad-6279b98a9c9f',
    authority: 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb',
    redirectUri: 'https://dev.ui.odms.n2p-nbnunify.com.au'
  },
  cache: {
    cacheLocation: 'localStorage', // or 'sessionStorage'
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),

    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    }),

    // ✅ MSAL Setup
    importProvidersFrom(
      MsalModule.forRoot(
        msalInstance,
        {
          interactionType: InteractionType.Redirect,
          authRequest: {
            scopes: ['user.read']
          }
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map([
            ['https://graph.microsoft.com/v1.0/me', ['user.read']]
          ])
        }
      )
    ),

    MsalService,
    MsalGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },

    ReplaceTextPipe,
    TitleTextPipe,
    Location
  ]
};
